import React from "react";
import styled from "styled-components";
import ContactInfo from "./ContactInfo";
import { Divider } from "@material-ui/core";

function RenderServicingContact({ claim, index, contact_length }) {
  return (
    <div style={{ display: "flex" }}>
      <ContactContainer key={index}>
        {claim.name && <ContactInfo label="Name">{claim.name}</ContactInfo>}
        {claim.phone && (
          <ContactInfo label="Mobile Number" isCopy>
            {claim.phone}
          </ContactInfo>
        )}
        {claim.email && (
          <ContactInfo label="Email Address" isCopy>
            {claim.email}
          </ContactInfo>
        )}
      </ContactContainer>
      <>
        {index !== contact_length - 1 && (
          <Divider
            orientation="vertical"
            style={{ marginRight: "4rem", marginLeft: "4rem" }}
          />
        )}
      </>
    </div>
  );
}

export default RenderServicingContact;

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 300px;
`;
